export default __webpack_public_path__ + "static/media/27.7ed80d61.jpg";